import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ProjectFlowState {
  // Project Details (from ProjectSettings)
  projectId: string | null;
  projectName: string;
  profileId: string;
  profileName: string;
  profileVersion: number;
  isFinalReview: boolean;
  selectedRetailerSkus: string[];
  // Products added via Add Products Modal for existing projects
  modalSelectedProducts: string[];

  // Actions
  setProjectDetails: (details: {
    projectId?: string | null;
    projectName?: string;
    profileId?: string;
    profileName?: string;
    profileVersion?: number;
  }) => void;
  setIsFinalReview: (val: boolean) => void;
  setSelectedRetailerSkus: (skus: string[]) => void;
  setModalSelectedProducts: (skus: string[]) => void;
  addModalSelectedProducts: (skus: string[]) => void;
  clearModalSelectedProducts: () => void;

  clearProjectFlow: () => void;
}

const initialState = {
  projectId: null,
  projectName: '',
  profileId: '',
  profileName: '',
  profileVersion: 0,
  isFinalReview: false,
  selectedRetailerSkus: [],
  modalSelectedProducts: []
};

export const useProjectFlowStore = create<ProjectFlowState>()(
  persist(
    (set) => ({
      ...initialState,

      setProjectDetails: (details) => {
        set((state) => {
          const newState = {
            ...state,
            ...(details.projectId !== undefined && { projectId: details.projectId }),
            ...(details.projectName !== undefined && { projectName: details.projectName }),
            ...(details.profileId !== undefined && { profileId: details.profileId }),
            ...(details.profileName !== undefined && { profileName: details.profileName }),
            ...(details.profileVersion !== undefined && { profileVersion: details.profileVersion })
          };

          return newState;
        });
      },

      setIsFinalReview: (val) => set({ isFinalReview: val }),

      setSelectedRetailerSkus: (skus) => set({ selectedRetailerSkus: skus }),

      setModalSelectedProducts: (skus) => set({ modalSelectedProducts: skus }),

      addModalSelectedProducts: (skus) =>
        set((state) => ({
          modalSelectedProducts: [...new Set([...state.modalSelectedProducts, ...skus])]
        })),

      clearModalSelectedProducts: () => set({ modalSelectedProducts: [] }),

      clearProjectFlow: () => set(initialState)
    }),
    {
      name: 'project-flow-storage',
    }
  )
);
